module.exports = __webpack_public_path__ + "img/oauth2_home.8acfd4d3.jpg";